(() => {
  if (window.wfsEssentialStickyMounted) return;
  window.wfsEssentialStickyMounted = true;

  // Essential changes the campaign suffix when a new timer is published.
  // Match only announcement bars, never its inline/product countdowns.
  const selector = '.countdown_annoucement_bar_wrapper, [class*="countdown_annoucement_bar_wrapper_"]';
  const root = document.documentElement;
  let current = null;
  let spacer = null;
  let frame = 0;
  let lastHeight = -1;
  const resizeObserver = typeof ResizeObserver === 'function'
    ? new ResizeObserver(schedule)
    : null;

  function schedule() {
    if (frame) return;
    frame = requestAnimationFrame(update);
  }

  function update() {
    frame = 0;
    const bar = Array.from(document.querySelectorAll(selector)).find((element) => {
      const style = getComputedStyle(element);
      const rect = element.getBoundingClientRect();
      return style.display !== 'none' && style.visibility !== 'hidden'
        && rect.width > 0 && rect.height > 0;
    }) || null;

    if (bar !== current) {
      if (current) {
        resizeObserver?.unobserve(current);
        current.classList.remove('wfs-essential-fixed');
      }
      current = bar;
      if (current) {
        if (!spacer) {
          spacer = document.createElement('div');
          spacer.id = 'wfs-essential-sticky-spacer';
          spacer.setAttribute('aria-hidden', 'true');
          document.body.prepend(spacer);
        }
        resizeObserver?.observe(current);
      }
    }

    if (current) {
      // Escape app containers that could clip or bound a fixed element.
      if (current.parentElement !== document.body) {
        document.body.insertBefore(current, spacer);
      }
      if (!current.classList.contains('wfs-essential-fixed')) {
        current.classList.add('wfs-essential-fixed');
      }
    }

    const height = current ? Math.ceil(current.getBoundingClientRect().height) : 0;
    if (height !== lastHeight) {
      lastHeight = height;
      root.style.setProperty('--wfs-essential-banner-height', `${height}px`);
      root.classList.toggle('wfs-essential-sticky-active', height > 0);
    }
  }

  function start() {
    // App embeds can arrive after the theme and can be replaced in the editor.
    new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.type === 'attributes'
        || [...mutation.addedNodes, ...mutation.removedNodes].some((node) => node.nodeType === 1))) {
        schedule();
      }
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden'],
    });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('load', schedule, { once: true });
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('shopify:section:unload', schedule);
    if (document.fonts?.ready) document.fonts.ready.then(schedule);
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
